const baseUrl = {
    development: 'http://localhost:8080',
    production: 'https://webapp.virtual.smartscholars.it'
};

export default{
    baseUrl: baseUrl[process.env.NODE_ENV || 'development'],
    googleClientId: '1088777211725-gvc9s3r11fuf118uuedu9c7bq0si3mpa.apps.googleusercontent.com'
};
